import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type SendUpgradeRecommendationMutationVariables = Types.Exact<{
  input: Types.SendUpgradeRecommendationInput
}>

export type SendUpgradeRecommendationMutation = {
  __typename?: 'Mutation'
  sendUpgradeRecommendation: boolean
}

export const SendUpgradeRecommendationDocument = gql`
  mutation SendUpgradeRecommendation($input: SendUpgradeRecommendationInput!) {
    sendUpgradeRecommendation(input: $input)
  }
`
export type SendUpgradeRecommendationMutationFn = ApolloReactCommon.MutationFunction<
  SendUpgradeRecommendationMutation,
  SendUpgradeRecommendationMutationVariables
>
export function useSendUpgradeRecommendationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendUpgradeRecommendationMutation,
    SendUpgradeRecommendationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendUpgradeRecommendationMutation,
    SendUpgradeRecommendationMutationVariables
  >(SendUpgradeRecommendationDocument, options)
}
export type SendUpgradeRecommendationMutationHookResult = ReturnType<
  typeof useSendUpgradeRecommendationMutation
>
export type SendUpgradeRecommendationMutationResult =
  ApolloReactCommon.MutationResult<SendUpgradeRecommendationMutation>
export type SendUpgradeRecommendationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendUpgradeRecommendationMutation,
  SendUpgradeRecommendationMutationVariables
>
